"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkDownField = exports.RedLaserField = exports.ServiceField = exports.CalculatedField = exports.DataField = exports.TagsField = exports.TimerField = exports.LinkField = exports.BusinessHoursField = exports.DocumentField = exports.ImageField = exports.SignatureField = exports.LabelField = exports.SliderField = exports.LocationField = exports.ColourField = exports.MoodField = exports.CountryField = exports.ChoiceField = exports.TimeField = exports.DateTimeField = exports.RatingField = exports.ToggleField = exports.NotesField = exports.CurrencyField = exports.PasswordField = exports.EMailField = exports.URLField = exports.NumberField = exports.TextField = exports.AISON_FIELD_TYPES = void 0;
exports.createField = createField;
exports.AISON_FIELD_TYPES = [
    'Text',
    'Number',
    'URL',
    'EMail',
    'Password',
    'Currency',
    'Notes',
    'Toggle',
    'Rating',
    'Date',
    'DateTime',
    'Time',
    'Choice',
    'Country',
    'Mood',
    'Colour',
    'Location',
    'Markdown',
    'Slider',
    'Label',
    'Signature',
    'Image',
    'Document',
    'BusinessHours',
    'Link',
    'Timer',
    'Tags',
    'Data',
    'Calculated',
    'Service',
    'RedLaser',
];
function createField(type, legend, store_as) {
    let field;
    switch (type) {
        case 'Text':
            field = TextField;
            break;
        case 'Number':
            field = NumberField;
            break;
        case 'URL':
            field = URLField;
            break;
        case 'EMail':
            field = EMailField;
            break;
        case 'Password':
            field = PasswordField;
            break;
        case 'Currency':
            field = CurrencyField;
            break;
        case 'Notes':
            field = NotesField;
            break;
        case 'Toggle':
            field = ToggleField;
            break;
        case 'Rating':
            field = RatingField;
            break;
        case 'Date':
        case 'DateTime':
            field = DateTimeField;
            break;
        case 'Time':
            field = TimeField;
            break;
        case 'Choice':
            field = ChoiceField;
            break;
        case 'Country':
            field = CountryField;
            break;
        case 'Mood':
            field = MoodField;
            break;
        case 'Colour':
            field = ColourField;
            break;
        case 'Location':
            field = LocationField;
            break;
        case 'Markdown':
            field = MarkDownField;
            break;
        case 'Slider':
            field = SliderField;
            break;
        case 'Label':
            field = LabelField;
            break;
        case 'Signature':
            field = SignatureField;
            break;
        case 'Image':
            field = ImageField;
            break;
        case 'Document':
            field = DocumentField;
            break;
        case 'BusinessHours':
            field = BusinessHoursField;
            break;
        case 'Link':
            field = LinkField;
            break;
        case 'Timer':
            field = TimerField;
            break;
        case 'Tags':
            field = TagsField;
            break;
        case 'Data':
            field = DataField;
            break;
        case 'Calculated':
            field = CalculatedField;
            break;
        case 'Service':
            field = ServiceField;
            break;
        case 'RedLaser':
            field = RedLaserField;
            break;
    }
    return new field(type, legend, store_as);
}
class BaseField {
    constructor(type, legend, store_as) {
        this.comment = '';
        this.control_style = '';
        this.custom_css = '';
        this.legend_style = '';
        this.hidden = false;
        this.required = false;
        this.readonly = false;
        this.virtual = false;
        this.hide_legend = false;
        this.indexed = false;
        this.visibility = null;
        this.defval = null;
        this.data_type = type;
        this.legend = legend;
        this.store_as = store_as;
    }
}
class TextField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.defval = '';
        this.mask = '';
        this.mask_prefix = '';
        this.mask_suffix = '';
        this.mask_drop_special_characters = true;
        this.mask_placeholder = '';
        this.regexp_pattern = '';
        this.regexp_flag_ignore_case = false;
    }
}
exports.TextField = TextField;
class NumberField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.defval = null;
        this.format = '%d';
    }
}
exports.NumberField = NumberField;
class URLField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.defval = '';
    }
}
exports.URLField = URLField;
class EMailField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.defval = '';
    }
}
exports.EMailField = EMailField;
class PasswordField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
    }
}
exports.PasswordField = PasswordField;
class CurrencyField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.defval = null;
    }
}
exports.CurrencyField = CurrencyField;
class NotesField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.defval = '';
        this.initial_height = 150;
        this.max_word_count = null;
        this.max_character_count = null;
    }
}
exports.NotesField = NotesField;
class ToggleField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.defval = null;
    }
}
exports.ToggleField = ToggleField;
class RatingField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.defval = null;
        this.max = 5;
    }
}
exports.RatingField = RatingField;
class DateTimeField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.date_showsas = true;
    }
}
exports.DateTimeField = DateTimeField;
class TimeField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
    }
}
exports.TimeField = TimeField;
class ChoiceField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.defval = null;
        this.multiple = false;
        this.depend = null;
        this.choices = null;
    }
}
exports.ChoiceField = ChoiceField;
class CountryField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
    }
}
exports.CountryField = CountryField;
class MoodField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
    }
}
exports.MoodField = MoodField;
class ColourField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.defval = null;
    }
}
exports.ColourField = ColourField;
class LocationField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.repin = false;
    }
}
exports.LocationField = LocationField;
class SliderField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.floor = 0;
        this.ceil = 10;
        this.step = 1;
        this.precision = 0;
        this.minLimit = null;
        this.maxLimit = null;
    }
}
exports.SliderField = SliderField;
class LabelField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.iframe = false;
        this.iframe_url = '';
        this.iframeSize = '';
        this.iframeWidth = '';
        this.iframeHeight = '';
        this.ifnew = '';
        this.ifextant = '';
    }
}
exports.LabelField = LabelField;
class SignatureField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
    }
}
exports.SignatureField = SignatureField;
class ImageField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.inline = false;
        this.crop = false;
        this.geolocation = false;
        this.multiple = false;
        this.max_images = 10;
        this.sizes = 'm';
        this.crop_sizes = {
            x: 0,
            y: 0,
            width: null,
            height: null,
        };
    }
}
exports.ImageField = ImageField;
class DocumentField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.button_type = 'primary';
        this.button_size = 'normal';
        this.button_icon = '';
        this.button_icon_media = null;
        this.button_text = '';
    }
}
exports.DocumentField = DocumentField;
class BusinessHoursField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.defval = null;
    }
}
exports.BusinessHoursField = BusinessHoursField;
class LinkField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.is_backreference = false;
        this.app = null;
        this.view = null;
        this.allow_new_record = true;
        this.new_record_label = '';
        this.display_as = 'dropdown';
        this.expression = '';
        this.count = 5;
        this.summary = [];
        this.filter = '';
    }
}
exports.LinkField = LinkField;
class TimerField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.auto_start = false;
        this.is_loop = false;
        this.show_controls = false;
        this.seconds = 60;
        this.actions = [];
    }
}
exports.TimerField = TimerField;
class TagsField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
    }
}
exports.TagsField = TagsField;
class DataField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.format = 'json';
    }
}
exports.DataField = DataField;
class CalculatedField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.display_as = null;
        this.calculation = '';
        this.format = 'string';
    }
}
exports.CalculatedField = CalculatedField;
class ServiceField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.actions = [];
        this.icon = null;
        this.icon_name = '';
        this.button_type = 'secondary';
        this.button_size = 'normal';
    }
}
exports.ServiceField = ServiceField;
class RedLaserField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
    }
}
exports.RedLaserField = RedLaserField;
class MarkDownField extends BaseField {
    constructor(type, legend, store_as) {
        super(type, legend, store_as);
        this.defval = '';
        this.initial_height = 300;
        this.max_word_count = null;
        this.max_character_count = null;
    }
}
exports.MarkDownField = MarkDownField;
//# sourceMappingURL=aison-field-data.js.map